<template>
  <div class="bg-white py-20 px-5 lg:px-8 lg:py-28">
    <div class="mx-auto max-w-7xl">
      <div class="max-w-2xl">
        <p class="eyebrow">What we do</p>
        <h2 class="mt-4 text-4xl font-extrabold tracking-tight text-navy-950 sm:text-5xl">
          Every exterior surface, covered.
        </h2>
        <p class="mt-5 text-lg leading-8 text-navy-600">
          The right method for each surface, whether that's pure water, low pressure or rotary cleaning, so
          nothing gets damaged and everything comes up clean.
        </p>
      </div>

      <div class="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <ServiceCard
          v-for="service in featured"
          :key="service.title"
          v-bind="service"
        />
      </div>

      <div class="mt-5 rounded-2xl border border-navy-100 bg-navy-50/50 p-6 sm:p-8">
        <p class="text-sm font-semibold uppercase tracking-[0.18em] text-navy-500">Also available</p>
        <ul class="mt-6 grid gap-x-8 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">
          <li v-for="service in more" :key="service.title" class="flex items-start gap-4">
            <span class="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-navy-600 shadow-sm ring-1 ring-navy-100">
              <i :class="[service.icon, 'text-sm']"></i>
            </span>
            <div>
              <h3 class="text-sm font-bold text-navy-950">{{ service.title }}</h3>
              <p class="mt-1 text-sm leading-6 text-navy-600">{{ service.description }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import ServiceCard from './ServiceCard.vue'
import roof from '../assets/roof.webp'
import windowImg from '../assets/window.webp'
import gutter from '../assets/gutter.webp'
import driveway from '../assets/driveway.webp'

const featured = [
  {
    icon: 'fas fa-cloud-rain',
    title: 'Roof Cleaning',
    description: 'Moss, algae and staining safely lifted from tiles to extend the life of your roof.',
    image: roof
  },
  {
    icon: 'fas fa-window-restore',
    title: 'Window Cleaning',
    description: 'Streak-free pure water cleaning that reaches upper floors without a ladder in sight.',
    image: windowImg
  },
  {
    icon: 'fas fa-water',
    title: 'Gutter Clearing',
    description: 'Vacuum system with an inspection camera, so you see the before and after.',
    image: gutter
  },
  {
    icon: 'fas fa-road',
    title: 'Driveways & Patios',
    description: 'Rotary surface cleaners for an even finish, with no stripes and no missed patches.',
    image: driveway
  }
]

const more = [
  { icon: 'fas fa-shower', title: 'Pressure Washing', description: 'Decking, walls, steps and anything else the weather has got to.' },
  { icon: 'fas fa-paint-roller', title: 'Render Cleaning', description: 'Algae, mould and lichen removed to restore the original finish.' },
  { icon: 'fas fa-house', title: 'Fascias & Soffits', description: 'Ground-safe telescopic poles and pure water for a clean edge.' },
  { icon: 'fas fa-sun', title: 'Conservatories', description: 'Glass, frames, roof, sills and gutters cleaned as one job.' },
  { icon: 'fas fa-solar-panel', title: 'Solar Panels', description: 'Dirt and debris cleared to keep energy output where it should be.' },
  { icon: 'fas fa-truck', title: 'Caravans & Motorhomes', description: 'Full exterior wash covering the roof, sides, windows, wheels and seals.' }
]
</script>
